import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/subcomponents/Header/index.jsx